import { makeWebsiteRequest } from '../tools';
import { Mention, MentionBlot } from 'quill-mention';
import { debounce } from '../tools';
import AuthorAvatar from '../AuthorAvatar.svelte';
const EVERYBODY_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z"/></svg>';
const CIRCLE_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>';
const mentionCache = {};
const getMentionOptions = async (searchTerm) => {
  if (mentionCache[searchTerm]) {
    return mentionCache[searchTerm];
  }
  const response = await makeWebsiteRequest({
    action: 'getMentionOptions',
    data: {
      query: searchTerm
    }
  });

  const data = response?.data || [];
  mentionCache[searchTerm] = data;
  return data;
};
const setupMentions = (Quill, quillConfig) => {
  // https://github.com/quill-mention/quill-mention?tab=readme-ov-file#getting-started
  Quill.register({ 'blots/mention': MentionBlot, 'modules/mention': Mention });
  // keep track of one-time use of author components
  const avatarInstances = {
    list: [],
    add: (instance) => {
      avatarInstances.list.push(instance);
    },
    destroy: () => {
      avatarInstances.list.forEach((instance) => {
        instance.$destroy();
      });
      avatarInstances.list = [];
    }
  };
  quillConfig.modules.mention = {
    allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
    mentionListClass: 'ql-custom-mention-list custom-scroll',
    mentionDenotationChars: ['@'],
    dataAttributes: ['id', 'value', 'type'],
    source: debounce(async (searchTerm, renderList, mentionChar) => {
      if (searchTerm.length < 2) {
        return;
      }
      const result = await getMentionOptions(searchTerm);
      const mapped = result.map((option) => ({
        id: option.id,
        value: option.value,
        type: option.type,
        extra: option.extra
      }));
      avatarInstances.destroy();
      renderList(mapped);
    }, 300),
    renderItem: (data) => {
      const mainDiv = document.createElement('div');
      mainDiv.className = 'flex align-center';
      // data.type is available for rendering different types of mentions (everybody, member, group, etc.)
      const avatarDiv = document.createElement('div');
      if (data.type === 0) {
        // everybody
        avatarDiv.innerHTML = EVERYBODY_SVG;
        avatarDiv.className = 'flex align-center';
      } else if (data.type === 1) {
        // member
        const instance = new AuthorAvatar({
          target: avatarDiv,
          props: {
            author: {
              memberId: data.id,
              name: data.value,
              extra: data.extra
            }
          }
        });
        avatarInstances.add(instance);
      } else if (data.type === 2) {
        avatarDiv.innerHTML = CIRCLE_SVG;
        avatarDiv.className = 'flex align-center';
      } else {
        console.debug('Unknown mention type:', data.type);
      }
      mainDiv.append(avatarDiv);
      const nameDiv = document.createElement('span');
      nameDiv.style.marginLeft = '10px';
      nameDiv.innerText = data.value;
      mainDiv.append(nameDiv);
      return mainDiv;
    }
  };
};
export default setupMentions;
